import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/air-purifier.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/chimney.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/coffee-maker.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/juicer.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/laptop.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/microwave.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/mobile.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/refrigerator.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/tv.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/vacuum-cleaner.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/washing-machine.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/categories/water-purifier.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/EmailCaptureSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/PublicationSort.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/components/ui/card.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
